<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex" :reloadFlag="reloadFlag"  :loginShow="loginShow" ></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人办事</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">养老服务</h2>
            <ul>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'OLD',nav_name:'高龄津贴'})"  class="civil_icon8"><img src="../../static/images/civil_icon9.png"><span>高龄津贴</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('OLDCalculate',{service_code:'OLD',nav_name:'高龄津贴待遇计算'})"  class="civil_icon6"><img src="../../static/images/gljtdyjs.png"><span>高龄津贴待遇计算</span></a></li>


              <!--<li  class="none"><a href="javascript:void(0)"  @click="urlTo('ylNeedEvaluation',{archive_type_code:'OLD',nav_name:'养老需求评估'})"  class="civil_icon2"><img src="../../static/new_imgs/ylxqpg.png"><span>养老需求评估</span></a></li>-->

              <!--<el-tooltip content="暂未开放" placement="bottom">-->
              <!--&lt;!&ndash;<li  class="none"><a href="javascript:void(0)"  @click="urlTo('ylNeedEvaluation','new_marry_card','养老需求评估')"  class="civil_icon2"><img src="../../static/new_imgs/ylxqpg.png"><span>养老需求评估</span></a></li>&ndash;&gt;-->
                <!--<li  class="none"><a href="javascript:void(0)"   class="civil_icon2"><img src="../../static/new_imgs/ylxqpg.png"><span>养老需求评估</span></a></li>-->

              <!--</el-tooltip>-->


            </ul>

          </div>
        </div>

        <div class="clear"></div>
        <div class="wraper">
          <div  class="civil_part1">
            <h2 class="tit">社会事务</h2>
            <ul style="margin-bottom: 100px;">
              <li  style="padding-right: 30px" class="none">
                <a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'CLP_HLF',nav_name:'残疾人护理补贴'})"  class="civil_icon4"><img src="../../static/new_imgs/cjrhlbt.png"><span>残疾人护理补贴</span></a>
              </li>
              <li style="padding-right: 30px" class="none">
                <a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'CLP_LIV',nav_name:'残疾人生活补贴'})"  class="civil_icon1"><img src="../../static/new_imgs/cjrshbt.png"><span>残疾人生活补贴</span></a>
              </li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('CLPCalculation',{service_code:'CLP',nav_name:'残疾人补贴待遇计算'})"  class="civil_icon2"><img src="../../static/images/cjrbtdyjs.png"><span>残疾人补贴待遇计算</span></a></li>


              <li style="padding-right: 30px" class="none">
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                <a href="javascript:void(0)"  @click="urlTo('guideIndex',{service_code:'JDST',nav_name:'节地生态葬补贴'})"   class="civil_icon5"><img src="../../static/new_imgs/jdst.png"><span>
节地生态葬补贴</span></a>
                <!--<a href="javascript:void(0)"     class="civil_icon1"><img src="../../static/new_imgs/jdst.png"><span>-->
                <!--节地生态葬补贴</span></a>-->
                <!--</el-tooltip>-->
              </li>
<!--              <li style="padding-right: 30px;padding-top: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('organinfoList',{yyType:'funeral',title:'报丧预约'})"  class="civil_icon3"><img src="../../static/images/bsyy.png"><span>报丧预约</span></a></li>-->

<!--              <li style="padding-right: 30px;padding-top: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('organinfoList',{yyType:'emplace',title:'骨灰寄存预约'})"  class="civil_icon9"><img src="../../static/images/ghjcyy.png"><span>骨灰寄存预约</span></a></li>-->

<!--              <li style="padding-right: 30px;padding-top: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('organinfoList',{yyType:'ceme',title:'墓位预定预约'})"  class="civil_icon3"><img src="../../static/images/mwydyy.png"><span>墓位预定预约</span></a></li>-->
              <li style="padding-right: 30px;padding-top: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('marrayServiceIndex',{yyType:'ceme',title:'婚姻家庭辅导'})"  class="civil_icon1"><img src="../../static/images/lhsqyy.png"><span>婚姻家庭辅导</span></a></li>
              <li style="padding-right: 30px;padding-top: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('shyjs',{yyType:'ceme',title:'身后一件事'})"  class="civil_icon1"><img src="../../static/images/shyjs.jpg"><span>身后一件事</span></a></li>


              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                <!--<a href="javascript:void(0)"  @click="showClause('servicesAppointmentMarry','new_marry_card','补领结婚证预约')"  class="civil_icon3">-->
                <!--<img src="../../static/new_imgs/bljhzyy.png">-->
                  <!--<span>补领结婚证预约</span>-->
              <!--</a>-->
                <!--</el-tooltip>-->
              <!--</li>-->

            </ul>
            <!--<ul style="margin-bottom: 100px">-->
              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                  <!--<a href="javascript:void(0)"   @click="showClause('servicesAppointmentMarry','new_divorce_card','补领离婚证预约')"  class="civil_icon4"><img src="../../static/new_imgs/bllhzyy.png"><span>-->
<!--补领离婚证预约</span></a>-->
                <!--</el-tooltip>-->
              <!--</li>-->
              <!--<li style="padding-right: 30px" class="none">-->
              <!--<el-tooltip content="暂未开放" placement="bottom">-->
                <!--<a href="javascript:void(0)"   @click="showClause('servicesAppointmentMarry','new_divorce_card','补领离婚证预约')"  class="civil_icon4"><img src="../../static/new_imgs/bllhzyy.png"><span>-->
<!--补领离婚证预约</span></a>-->
              <!--</el-tooltip>-->
            <!--</li>-->
              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                <!--<a href="javascript:void(0)"   @click="showClause('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon5"><img src="../../static/new_imgs/bzywblyy.png"><span>-->
<!--殡葬业务预约</span></a>-->
                <!--</el-tooltip>-->
              <!--</li>-->
              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                  <!--<a href="javascript:void(0)"  @click="showClause('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon6"><img src="../../static/new_imgs/yysm.png"><span>扫墓预约</span></a>-->
                <!--</el-tooltip>-->
              <!--</li>-->
            <!--</ul>-->
            <!--<ul>-->
              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                  <!--<a href="javascript:void(0)"   @click="showClause('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon7"><img src="../../static/new_imgs/dwsm.png"><span>代为扫墓</span></a>-->
                <!--</el-tooltip>-->
              <!--</li>-->
              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                  <!--<a href="javascript:void(0)"  @click="showClause('servicesAppointmentMarry','marry','结婚登记预约')"  class="civil_icon1"><img src="../../static/new_imgs/jhdjyy.png"><span>结婚登记预约</span></a>-->
                <!--</el-tooltip>-->
              <!--</li>-->
              <!--<li style="padding-right: 30px" class="none">-->
                <!--<el-tooltip content="暂未开放" placement="bottom">-->
                  <!--<a href="javascript:void(0)"  @click="showClause('servicesAppointmentMarry','divorce','离婚登记预约')"  class="civil_icon2"><img src="../../static/new_imgs/lhdjyy.png"><span>-->
<!--离婚登记预约</span></a>-->
                <!--</el-tooltip>-->
              <!--</li>-->

            <!--</ul>-->



          </div>
        </div>
        <div class="clear"></div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">儿童福利</h2>
            <ul>
              <li  style="padding-right: 30px;" class="none">
                <el-tooltip content="孤儿生活费" placement="bottom">
<!--                <a href="javascript:void(0)"   class="civil_icon0"><img src="../../static/images/icon14_lock.png"><span>孤儿</span></a>-->
                </el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'ORP',nav_name:'孤儿生活费'})"  class="civil_icon3"><img src="../../static/images/icon14.png"><span>孤儿生活费</span></a>
              </li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('ORPCalculation',{service_code:'ORP',nav_name:'孤儿生活费待遇计算'})"  class="civil_icon1"><img src="../../static/images/geshfdyjs.png"><span>孤儿生活费待遇计算</span></a></li>

              <li  style="padding-right: 30px" class="none">
                <el-tooltip content="事实无人抚养儿童生活费" placement="bottom">
<!--                <a href="javascript:void(0)"     class="civil_icon0"><img src="../../static/images/icon13_lock.png"><span>事实无人抚养<br />儿童</span></a>-->
                </el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'BLAN_ORP',nav_name:'事实无人抚养儿童生活费'})"  class="civil_icon7"><img src="../../static/images/icon13.png"><span>事实无人抚养<br />儿童生活费</span></a>

              </li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('BLANORPCalculation',{service_code:'BLAN_ORP',nav_name:'事实无人抚养儿童生活费待遇计算'})"  class="civil_icon9"><img src="../../static/images/sswrfyetdyjs.png"><span>事实无人抚养儿童生活费待遇计算</span></a></li>

              <li  style="padding-right: 30px;padding-top: 30px" class="none">
<!--                <el-tooltip content="困境儿童" placement="bottom">-->
<!--             &lt;!&ndash;   <a href="javascript:void(0)"    class="civil_icon0"><img src="../../static/images/icon16_lock.png"><span>困境儿童</span></a>&ndash;&gt;-->
<!--                </el-tooltip>-->
<!--                <a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'POC',nav_name:'困境儿童'})"  class="civil_icon3"><img src="../../static/images/icon16.png"><span>困境儿童</span></a>-->
              </li>
              <!--<li  ><a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'SPEC_ORP',nav_name:'特殊困难儿童'})"  class="civil_icon2"><img src="../../static/images/civil_icon4.png"><span>特殊困难儿童</span></a></li>-->

            </ul>
          </div>
        </div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">婚姻登记</h2>
            <div>
              <ul>
                <li  style="padding-right: 30px;" class="none">
<!--                  <el-tooltip content="结婚登记预约" placement="bottom">-->
<!--                    &lt;!&ndash;                <a href="javascript:void(0)"   class="civil_icon0"><img src="../../static/images/icon14_lock.png"><span>孤儿</span></a>&ndash;&gt;-->
<!--                  </el-tooltip>-->
                  <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IA',title:'结婚登记预约', swFlag: 0})"  class="civil_icon3"><img src="../../static/images/jhdjyy.png"><span>结婚登记预约</span></a>
                </li>
                <li  style="padding-right: 30px;" class="none">
                  <!--                  <el-tooltip content="离婚申请预约" placement="bottom">-->
                  <!--                    &lt;!&ndash;                   <a href="javascript:void(0)"    class="civil_icon0"><img src="../../static/images/icon16_lock.png"><span>困境儿童</span></a>&ndash;&gt;&ndash;&gt;-->
                  <!--                  </el-tooltip>-->
                  <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IBSQ',title:'离婚申请预约'})"  class="civil_icon1"><img src="../../static/images/lhsqyy.png"><span>离婚申请预约</span></a>
                </li>
                <li  style="padding-right: 30px" class="none">
<!--                  <el-tooltip content="离婚登记预约" placement="bottom">-->
<!--                    &lt;!&ndash;                <a href="javascript:void(0)"     class="civil_icon0"><img src="../../static/images/icon13_lock.png"><span>事实无人抚养<br />儿童</span></a>&ndash;&gt;-->
<!--                  </el-tooltip>-->
                  <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IB',title:'离婚登记预约', swFlag: 0})"  class="civil_icon5"><img src="../../static/images/lhdjyy.png"><span>离婚登记预约<br /></span></a>

                </li>

                <li style="padding-right: 30px;" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICA',title:'补领结婚证预约', swFlag: 0})"  class="civil_icon7"><img src="../../static/images/bljhzyy.png"><span>补领结婚证预约</span></a></li>

                <li style="padding-right: 30px;padding-top: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICB',title:'补领离婚证预约', swFlag: 0})"  class="civil_icon2"><img src="../../static/images/bllhzyy.png"><span>补领离婚证预约</span></a></li>


                <!--<li  ><a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'SPEC_ORP',nav_name:'特殊困难儿童'})"  class="civil_icon2"><img src="../../static/images/civil_icon4.png"><span>特殊困难儿童</span></a></li>-->
                <li  style="padding-right: 30px;padding-top: 30px;" class="none">
                  <el-tooltip content="涉外、涉港澳台居民及华侨结婚登记预约" placement="bottom"></el-tooltip>
                  <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IA',title:'涉外、涉港澳台居民及华侨结婚登记预约', swFlag: 1})"  class="civil_icon3"><img src="../../static/images/jhdjyy.png"><span>涉外、涉港澳台居民及华侨结婚登记预约</span></a>
                </li>
                <li  style="padding-right: 30px;padding-top: 30px" class="none">
                  <el-tooltip content="涉外、涉港澳台居民及华侨离婚申请预约" placement="bottom">
                    <!--                   <a href="javascript:void(0)"    class="civil_icon0"><img src="../../static/images/icon16_lock.png"><span>困境儿童</span></a>&ndash;&gt;-->
                  </el-tooltip>
                  <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IBSQ',title:'涉外、涉港澳台居民及华侨离婚申请预约', swFlag: 1})"  class="civil_icon1"><img src="../../static/images/lhsqyy.png"><span>涉外、涉港澳台居民及华侨离婚申请预约</span></a>
                </li>
                <li  style="padding-right: 30px;padding-top: 30px;" class="none">
                  <el-tooltip content="涉外、涉港澳台居民及华侨离婚登记预约" placement="bottom"></el-tooltip>
                  <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IB',title:'涉外、涉港澳台居民及华侨离婚登记预约', swFlag: 1})"  class="civil_icon5"><img src="../../static/images/lhdjyy.png"><span>涉外、涉港澳台居民及华侨离婚登记预约<br /></span></a>
                </li>
                <li style="padding-right: 30px;padding-top: 30px;" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICA',title:'涉外、涉港澳台居民及华侨补领结婚证预约', swFlag: 1})"  class="civil_icon7"><img src="../../static/images/bljhzyy.png"><span>涉外、涉港澳台居民及华侨补领结婚证预约</span></a></li>
                <li style="padding-right: 30px;padding-top: 30px;" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICB',title:'涉外、涉港澳台居民及华侨补领离婚证预约', swFlag: 1})"  class="civil_icon2"><img src="../../static/images/bllhzyy.png"><span>涉外、涉港澳台居民及华侨补领离婚证预约</span></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">社会救助</h2>
            <ul>
              <li style="padding-right: 30px;" class="none">
<!--                <a href="http://220.167.138.85:9091/sri/nointercept/sri/register!register.do#"   target="_blank"  class="civil_icon3"><img src="../../static/images/icon9.png"><span>社会救助</span></a>-->
                <a href="https://mzt.qinghai.gov.cn/public/pages/client/apply-external/index"   target="_blank"  class="civil_icon3"><img src="../../static/images/icon9.png"><span>社会救助</span></a>

              </li>
           <!--   <li style="padding-right: 30px;" class="none">
                <a href="javascript:void(0)"   @click="urlTo('BLANCalculation',{service_code:'BLAN',nav_name:'低保金计算'})"  class="civil_icon4"><img src="../../static/images/dbjjs.png"><span>低保金计算</span></a>

              </li>-->
              <li style="padding-right: 30px;" class="none">
                <a href="javascript:void(0)"   @click="urlTo('NTFCalculation',{service_code:'NTF',nav_name:'特困供养补贴计算'})"  class="civil_icon9"><img src="../../static/images/tkgybtdyjs.png"><span>特困供养补贴计算</span></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
        <!--<div class="wraper">-->
          <!--<div class="civil_part1">-->
            <!--<h2 class="tit">社会救助</h2>-->
            <!--<ul>-->
              <!--<li><a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'BLAN',nav_name:'城乡低保'})" class="civil_icon1"><img src="../../static/images/civil_icon1.png"><span>城乡低保</span></a></li>-->
              <!--<li><a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'NTF',nav_name:'特困供养'})"  class="civil_icon2"><img src="../../static/images/civil_icon2.png"><span>特困供养</span></a></li>-->
              <!--<li class="none"><a href="javascript:void(0)"   @click="urlTo('guideIndex',{service_code:'TEMP',nav_name:'临时救助'})"  class="civil_icon3"><img src="../../static/images/civil_icon3.png"><span>临时救助</span></a></li>-->
            <!--</ul>-->
          <!--</div>-->
        <!--</div>-->


      </div>
    </div>
    <div style="line-height: 35px;">
      <el-dialog @close="close(1)" :visible.sync="clauseShow" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">{{cTitle}}</div>
        <div v-if="cContent!==''" style="font-size: 14px;margin-left: 40px;margin-right: 35px;"><p v-html="this.cContent">{{cContent}}</p></div>
        <div v-else>
          <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
            <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
            <div>暂无数据</div>
          </div>
        </div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button  type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
import consts from "../consts";
export default {
  name: "apply-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      pageNum:1,
      pageSize:6,
      tsData:[],
      jyData:[],
      zxData:[],
      clauseShow:false,
      cContent:'',
      cTitle:'',
      url:'',
      title:'',
      service_code:'',
        reloadFlag:false,
        loginShow:false,
        gotoIndex:false,
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  created(){
      this.qhszwtLogin();
  },
  methods: {
      qhszwtLogin(){

          let code=this.$route.query.code;
          let token_code=this.$route.query.token_code;

          var userInfo=this.$cookies.get('userInfo')
          if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1) {
              if(token_code && token_code !=''){
                  const options = {
                      code: code,
                      token_code: token_code
                  }
                  console.log("进来了131")
                  var tt = this;
                  this.$https.post("api/pu/qhzwfwLogin.do", options, response => {
                      console.log("青松办登录返回：",response)
                      if (response.status === 200 && response.data.code === 200 && response.data.data) {
                          tt.$cookies.set("userId", response.data.data.userId, "1D")
                          tt.$cookies.set("token", response.data.data.token, "1D")
                          tt.$cookies.set("userInfo", response.data.data, "1D")
                          tt.$cookies.set("isLegal", response.data.data.isLegal, "1D")
                          tt.isLogin = true;
                          tt.userName = response.data.data.userName;
                          tt.reloadFlag = true;
                      }
                  })

              }else{
                  console.log("324324")
              }
          }else{
              console.log("进来了1135")
          }
      },
    urlTo(url,params){
          if(url==='shyjs'){
              var userInfo=this.$cookies.get('userInfo')
              if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){

                  this.loginShow=true;
                  this.gotoIndex=true;
                  return;
              }
          //判断是否统一认证登录，如果不是，提示去统一认证平台登录
              var tt=this;
              this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
                  if (response.status === 200 && response.data.code===200 ) {
                      if(!response.data || !response.data.data){
                          tt.$toast.fail({duration:3000,message:"用户数据安全检查失败，请重新登录!"});
                          tt.loginShow=true;
                          tt.gotoIndex=true;
                          return;
                      }
                      let data=response.data.data;
                      //判断是否第三方登录
                      if(!data.tyrzUserIdCode || data.tyrzUserIdCode===''){
                          //提示并调整到统一认证登录
                          tt.$dialog.confirm({title:'提示',message:'本业务需要通过青海民政统一认证登录校验，是否跳转去认证?',confirmButtonColor:'red'})
                              .then(() => {
                                  let tyrzUrl=consts.SysSet.tyrzUrl;
                                  window.location.href= tyrzUrl;
                              })
                              .catch(() => {

                              });
                      }else {
                          //自身系统是否实名认证校验
                          // if(data.isCertification !== '1'){
                          //     tt.$dialog.confirm({title:'提示',message:'请先实名认证！',confirmButtonColor:'red'})
                          //         .then(() => {
                          //             tt.urlTo('peopleCertification');
                          //         })
                          //         .catch(() => {
                          //
                          //         });
                          // }else{
                          window.location.href = "https://mzt.qinghai.gov.cn/shyjs_pc?type=2&openId="+data.userId;
                          // }
                      }


                  } else {
                      if(tt.loadShow){
                          tt.loadShow.close();
                      }
                      tt.$router.push({path:'/peopleLogin'});
                  }
              },err=>{
                  console.log(err);
                  if(tt.loadShow){
                      tt.loadShow.close();
                  }
              });
          }else{
           this.$router.push({path:url,query:params||{}});
          }
    },
    showClause(url,service_code,title){
      this.$message({
        message: '暂未开放',
        type: 'warning'
      });
      return;
      this.url=url;
      this.service_code=service_code;
      this.title=title;
      this.clauseClose();
      // var t=this;
      //   this.$https.get("api/pu/clause/getClauseContentByType.do",{cType:service_code},response=>{
      //     if (response.status === 200 && response.data.code===200) {
      //       t.cTitle=response.data.data.cTitle;
      //       t.cContent=response.data.data.cContent;
      //     }
      //     t.clauseShow=true;
      //   })
    },
    clauseClose(){
      this.clauseShow=false;
      this.urlTo(this.url,{service_code:this.service_code,title:this.title})
    },
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ApplyIndex_qh.vue